// extracted by mini-css-extract-plugin
module.exports = {"TopSection":"TopSection_TopSection__1BSPw","SearchType":"TopSection_SearchType__2axJl","TopSectionSubtitle":"TopSection_TopSectionSubtitle__2Rg8t"};